import Dashboard from '../components/Dashboard';
import FormLayoutDemo from '../components/FormLayoutDemo';
import InputDemo from '../components/InputDemo';
import FloatLabelDemo from '../components/FloatLabelDemo';
import ButtonDemo from '../components/ButtonDemo';
import TableDemo from '../components/TableDemo';
import ListDemo from '../components/ListDemo';
import TreeDemo from '../components/TreeDemo';
import PanelDemo from '../components/PanelDemo';
import OverlayDemo from '../components/OverlayDemo';
import MediaDemo from '../components/MediaDemo';
import MenuDemo from '../components/MenuDemo';
import MessagesDemo from '../components/MessagesDemo';
import FileDemo from '../components/FileDemo';
import MiscDemo from '../components/MiscDemo';
import CrudDemo from '../pages/CrudDemo';
import Help from '../pages/Help';
import EmptyPage from '../pages/EmptyPage';
import InvalidStateDemo from '../components/InvalidStateDemo';
import TimelineDemo from '../pages/TimelineDemo';
//NEW
import Product from 'pages/Inventory/Product';
import Others from 'pages/Other/Others';

import Supplier from 'pages/Supplier/Supplier';
import Requisition from 'pages/Requisition/Requisition';
import WorkOrder from 'pages/WorkOrder/WorkOrder';
import Chalan from 'pages/Chalan/Chalan';
import Stock from 'pages/Stock/Stock';
import SaleManually from 'pages/SaleManually/SaleManually';
import Sale from 'pages/Sale/Sale'
import SaleDetails from 'pages/SaleDetails/SaleDetails';
import ReturnToSupplier from 'pages/ReturnToSupplier/ReturnToSupplier';
import ReturnFromEmployee from 'pages/ReturnFromEmployee/ReturnFromEmployee';
import Registration from 'pages/Registration/Registration'
import Report from 'pages/Report/Report';
import {ChangePassword} from '../pages/UpdateProfile/ChangePassword';
import Logout from 'pages/Logout/Logout';


export const routes = [
    { path: '/', element: <Dashboard />},
    { path: '/formlayout', element: <FormLayoutDemo />},
    { path: '/input', element: <InputDemo />},
    { path: '/floatlabel', element: <FloatLabelDemo />},
    { path: "/invalidstate", element: <InvalidStateDemo />},
    { path: '/button', element: <ButtonDemo />},
    { path: '/table', element: <TableDemo />},
    { path: '/list', element: <ListDemo />},
    { path: '/tree', element: <TreeDemo />},
    { path: '/panel', element: <PanelDemo />},
    { path: '/overlay', element: <OverlayDemo />},
    { path: '/media', element: <MediaDemo />},
    { path: '/menu/*', element: <MenuDemo />},
    { path: '/messages', element: <MessagesDemo />},
    { path: '/file', element: <FileDemo />},
    { path: '/misc', element: <MiscDemo />},
    { path: '/crud', element: <CrudDemo />},
    { path: '/timeline', element: <TimelineDemo />},
    { path: '/help', element: <Help />},
    { path: '/empty', element: <EmptyPage />},

    { path: '/users', element: <Registration />},

    { path: '/product', element: <Product />},
    { path: '/others', element: <Others />},


    { path: '/supplier', element: <Supplier />},
    { path: '/requisition', element: <Requisition />},
    { path: '/workorder', element: <WorkOrder />},
    { path: '/chalan', element: <Chalan />},
    { path: '/stock', element: <Stock />},
    { path: '/sale_manually', element: <SaleManually />},
    { path: '/sale', element: <Sale />},
    { path: '/sale_details', element: <SaleDetails />},


    { path: '/return_to_supplier', element: <ReturnToSupplier />},
    { path: '/return_from_employee', element: <ReturnFromEmployee />},

    { path: '/report', element: <Report />},
    { path: '/change_password', element: <ChangePassword />},
    { path: '/logout', element: <Logout />},


];

export const routesStore = [
    { path: '/', element: <Dashboard />},
    { path: '/requisition', element: <Requisition />},
    { path: '/workorder', element: <WorkOrder />},
    { path: '/chalan', element: <Chalan />},
    { path: '/stock', element: <Stock />},
    { path: '/report', element: <Report />},
    { path: '/change_password', element: <ChangePassword />},
    { path: '/logout', element: <Logout />},


];

export const routesSale = [

    { path: '/sale', element: <Sale />},
    { path: '/change_password', element: <ChangePassword />},
    { path: '/logout', element: <Logout />},

];

export const routesReport = [
    { path: '/report', element: <Report />},
    { path: '/change_password', element: <ChangePassword />},
    { path: '/logout', element: <Logout />},

];